import { useSearchParams } from 'client/shared/hooks/use-search-params';

export function useDemoPollyFips(): string | null {
  const { demoPollyFips } = useSearchParams();
  return demoPollyFips();
}
